import { useQuery } from "@tanstack/react-query";

import { getCropMixComposerCrops } from "services";

import { GET_CROP_MIX_COMPOSER_CROPS } from "consts";

export const useGetCropMixComposerCrops = (cropMixId: string | undefined) =>
  useQuery({
    queryKey: [GET_CROP_MIX_COMPOSER_CROPS, cropMixId],
    queryFn: async ({ signal }) => {
      if (!cropMixId) return [];

      const response = await getCropMixComposerCrops({ cropMixId, signal });
      return response || [];
    },
    enabled: !!cropMixId,
    placeholderData: [],
  });
